import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function WheelOfDestiny() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="WheelOfDestiny" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Wheel of Destiny</h1>
      <img
        src="/thumbnails/WheelOfDestiny.png"
        alt="Wheel of Destiny game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Wheel of Destiny</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Wheel of Destiny is a simple tool for helping make difficult decisions or to pick random outcomes. Spin the wheel to get a random result from a customizable set of options. Perfect for games, challenges, or just adding some fun randomness to your day!
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Choose from pre-made wheels or create your own custom wheel with any options you like.</li>
            <li>Spin the wheel to get a random result.</li>
            <li>Use the results for games, challenges, or decision making.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
            <li>Multiplayer online play. Everyone sees the wheel spin</li>
            <li>Customizable wheels with your own options - all players can help contribute</li>
            <li>Pre-made wheels for common use cases like dice rolls, yes/no questions, card picks, and more</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Use the wheel to add an element of chance to your games and challenges.</li>
            <li>Get creative with custom wheels for unique games or decision making.</li>
            <li>Try the pre-made wheels for quick and easy random outcomes.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Wheel of Destiny</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Play Wheel of Destiny on your own or online with friends or other players.
        </p>
        <PlayGameLink game="WheelOfDestiny"  gameTitle="Wheel of Destiny"  />
      </section>
    </div>
  );
}
